export default __webpack_public_path__ + "static/media/upload-active.1c88057e.svg";